
import Helpers from "@/helpers.js";
import { baseUrl } from "./vue.config";
import ModelsService from "@/services/models.service.js";
import moment from 'moment';
import 'moment/locale/it';
moment.locale('it');

export const widgetMixin = {
    computed: {
        urlImmagineFull : function(){
            return process.env.VUE_APP_BASEMEDIA_URL + this.widgetData.UrlImmagine;
        }
    }
}

export const imgMixin = {
    methods: {
        getUrlImmagineFull(urlImmagine, full = false){
            if(urlImmagine && !full){
                return  process.env.VUE_APP_BASEMEDIA_URL + urlImmagine;
            }
            else if(urlImmagine && full){
                return urlImmagine;
            }else{
                return  baseUrl + 'images/CressiNoPhoto.png'
            }
        },
        getUrlImmagineArticolo(urlImmagine){
            if(urlImmagine){
                return process.env.VUE_APP_BASEMEDIA_URL_ARTICLES + urlImmagine;
            }else{
                return  baseUrl + 'images/CressiNoPhoto.png'
            }
        }
    }
}

export const priceMixin = {
    methods: {
        formatNumber: function(number, decimals, dec_point, thousands_sep){
            return Helpers.number_format(number, decimals, dec_point, thousands_sep);
        }
    }
}

export const SogliaArancioneMixin = {
    computed:{
        limitOrangeSemaphore: function(){
            return this.$store.getters.getSogliaArancoione;
        }
    }
}

export const CalcoloSoglieMixin = {
    computed:{
        inStock: function(){
            return this.variant.Stock == 2;
        },
        outOfStock: function(){
            return this.variant.Stock == 0;
        },
        fewPieces: function(){
            return this.variant.Stock == 1;
        },
    },
    methods: {
        inStockStorico: function(variant){
            return variant.Disponibilita > this.limitOrangeSemaphore;
        },
        outOfStockStorico: function(variant){
            return variant.Disponibilita == 0;
        },
        fewPiecesStorico: function(variant){
            return variant.Disponibilita > 0 && variant.Disponibilita <= this.limitOrangeSemaphore
        },
        inStockBack: function(val){
            return val.Stock == 2;
        },
        outOfStockBack: function(val){
            return val.Stock == 0;
        },
        fewPiecesBack: function(val){
            return val.Stock == 1;
        },  
    }
}

export const EmailMixin = {
    methods: {
        validateEmail: function(email){
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    }
}

export const modelMixin = {
    methods: {
        getModels: function(token, catalogoSelected, categoriaSelected, emitEvent = true){
            ModelsService.filterModels(token, "", catalogoSelected, categoriaSelected).then(
                data => {
                    if(!data){
                        this.$router.push("/");
                    }
                    else if(data && data.length == 0 && emitEvent) {
                        this.$emit("ListModelReady", ["no-models"]);
                    }
                    else{
                        this.listaModelli = data;
                        if(emitEvent){
                            this.$emit("ListModelReady", this.listaModelli);
                        }
                    }
                }
            ).catch(
                (err) => {console.log(err)}
            )
        },
    }
}

export const valutaMixin = {
    computed: {
        simboloValuta: function(){
            return this.$store.getters.getAnagraficaAzienda?.SimboloValuta
        },
        codiceValuta: function(){
            return this.$store.getters.getAnagraficaAzienda?.Valuta;
        }
    }
}


export const risorseMixin = {
    computed: {
        risorse: function(){
            return this.$store.getters.getResources(this.$store.getters.getLingua);
        }
    }
}

export const dateMixin = {
    methods:{
        formatDate: function(date, format = 'DD/MM/YYYY HH:mm') {
            let d = moment(date).format(format);
            if(d == "Invalid date")d = "-";
            return d;
        },
        formatDateNoOre: function(date, format = 'DD/MM/YYYY') {
            let d = moment(date).format(format);
            if(d == "Invalid date")d = "-";
            return d;
        },
        formatDateNoOreJQuery: function(date, format = 'yyyy-MM-DD') {
            let d = moment(date).format(format);
            if(d == "Invalid date")d = "";
            return d ;
        },
        getLiteralMonth: function(date, format = 'MMMM'){
            let d = moment(date).format(format);
            if(d === "Invalid date")d = "-";
            return d;
        },
        getDay: function(date, format = 'DD'){
            let d = moment(date).format(format);
            if(d === "Invalid date")d = "-";
            return d;
        },
        getYear: function(date, format = 'YYYY'){
            let d = moment(date).format(format);
            if(d === 'Invalid date')d = "-";
            return d;
        },
        formatDateNoOre2: function(date, format = 'YYYY/MM/DD') {
            let d = moment(date,'YYYY-MM-DD').format(format);
            if(d == "Invalid date")d = "-";
            return d;
        }
    }
}
